import { empresasService } from '@/services/empresas.service';
import type { Empresa } from '@/types/types';
import { filtrarEmpresasConCorrecciones } from '@/utils/correccionesPendientes';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface UseCorreccionesPendientesResult {
  empresas: Empresa[];
  count: number;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export function useCorreccionesPendientes(): UseCorreccionesPendientesResult {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const refetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const todasLasEmpresas = await empresasService.getAll();
      setEmpresas(filtrarEmpresasConCorrecciones(todasLasEmpresas));
    } catch {
      // Error silencioso: no debe romper el header ni lanzar excepciones no controladas
      setEmpresas([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch, location.pathname]);

  return { empresas, count: empresas.length, isLoading, refetch };
}
